module.exports = __webpack_public_path__ + "static/media/home_placeholder.75e7d211.png";